import { Sheet, SheetViewProps } from '@silk-hq/components';
import { cn } from '../../lib/classNameHelpers';

type PersistentBottomBarProps = {
  height?: string;
  className?: string;
  children: React.ReactNode;
  defaultPresented?: boolean;
} & SheetViewProps;

export function PersistentBottomBar({
  children,
  className,
  height = '56px',
  inertOutside = false,
  swipeDismissal = false,
  defaultPresented = true,
  onClickOutside = { dismiss: false },
  onPresentAutoFocus = { focus: false },
  ...props
}: PersistentBottomBarProps) {
  return (
    <Sheet.Root license="commercial" defaultPresented={defaultPresented}>
      <Sheet.Portal>
        <Sheet.View
          className="-bottom-px z-40 w-full"
          style={{
            height: height,
          }}
          detents={height}
          inertOutside={inertOutside}
          onClickOutside={onClickOutside}
          swipeDismissal={swipeDismissal}
          onPresentAutoFocus={onPresentAutoFocus}
          {...props}
        >
          <Sheet.Content className={cn('h-full bg-backgroundPrimary box-border', className)}>
            <Sheet.SpecialWrapper.Root>
              <Sheet.SpecialWrapper.Content>
                <div>{children}</div>
              </Sheet.SpecialWrapper.Content>
            </Sheet.SpecialWrapper.Root>
          </Sheet.Content>
        </Sheet.View>
      </Sheet.Portal>
    </Sheet.Root>
  );
}
